
export enum MemberType {

    Student = 1,
    Resident = 2,
    Fellow = 3,
    Physician = 4,
    //pga: coding-4909 new member type
    Retired = 5
}

export enum AccountType {

    MEDICALSCHOOL,
    RESIDENCY,
    FELLOWSHIP,
    BOARDCERTIFICATION
}

export enum NotificationStatus {
    NewMembershipSuccessful,
    RenewalSuccesful,
    AutoRenewalActive,
    CurrentInstallmentsActive,
    FutureInstallmentsActive,
    NotReadyForRenewal,
    ReadyToRestart,
    Ineligible,
    SectionApplication_Ineligible,
    SectionApplication_Comp,
    Error,
    None
}
